import { createApi, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/dist/query/react'
import { apiPath, baseUrl } from 'config'
import { AddressString } from 'types'
import { FeeSummary, FeeTransactionsResponse } from 'types/fee'

import { setFeeData } from 'store/reducers-common/Pool/slice'
import { getSignature } from 'utils/getSignature'

export const queryFee = createApi({
  baseQuery: fetchBaseQuery({ baseUrl }),
  endpoints: (builder) => ({
    getFeeSummaryByFundAddress: builder.query<FeeSummary, string>({
      queryFn: async (fundAddress, _api, _extraOptions, baseQuery) => {
        const url = `${apiPath.feeSummary}?fundAddress=${fundAddress}`

        const { deadline, signature } = await getSignature({
          primaryType: 'GetFee',
          url,
        })

        const result = await baseQuery({
          headers: { deadline: `${deadline}`, signature },
          url,
        })
        if (!result.data) {
          return { error: result.error as FetchBaseQueryError }
        }

        return { data: result.data as FeeSummary }
      },
    }),
    getFeeSummaryByPoolAddress: builder.query<FeeSummary, string>({
      queryFn: async (poolAddress, _api, _extraOptions, baseQuery) => {
        const url = `${apiPath.feeSummary}?poolAddress=${poolAddress}`

        const { deadline, signature } = await getSignature({
          primaryType: 'GetFee',
          url,
        })

        const result = await baseQuery({
          headers: { deadline: `${deadline}`, signature },
          url,
        })
        if (!result.data) {
          return { error: result.error as FetchBaseQueryError }
        }

        return { data: result.data as FeeSummary }
      },
    }),
    getFeeTransactions: builder.query<
      FeeTransactionsResponse,
      {
        endDate?: string
        fundAddress: AddressString
        limit: number
        page: number
        poolAddress: AddressString
        startDate?: string
      }
    >({
      queryFn: async (arg, _api, _extraOptions, baseQuery) => {
        const { endDate, fundAddress, limit, page, poolAddress, startDate } = arg
        let url = `${apiPath.fee}?fundAddress=${fundAddress}&poolAddress=${poolAddress}&limit=${limit}&page=${page}`
        if (startDate) url += `&startDate=${startDate}`
        if (endDate) url += `&endDate=${endDate}`

        const { deadline, signature } = await getSignature({
          primaryType: 'GetFee',
          url,
        })

        const result = await baseQuery({
          headers: { deadline: `${deadline}`, signature },
          url,
        })
        if (!result.data) {
          return { error: result.error as FetchBaseQueryError }
        }

        const data = result.data as FeeTransactionsResponse

        _api.dispatch(setFeeData(data))

        return { data }
      },
    }),
  }),
  reducerPath: 'fee',
})

export const { useGetFeeSummaryByFundAddressQuery, useGetFeeSummaryByPoolAddressQuery, useGetFeeTransactionsQuery } =
  queryFee
